import { bindable, bindingMode } from 'aurelia-framework';

export class ToggleSwitch {
  @bindable({ defaultBindingMode: bindingMode.twoWay }) value: boolean;
  @bindable onToggle: Function;

  valueChanged(newValue: boolean) {
    setTimeout(() => {
      if (this.onToggle) {
        this.onToggle({ newValue: this.value });
      }
    }, 0);
    return true;
  }
}